import { render } from "./PlayersRoom.vue?vue&type=template&id=5012de2e&scoped=true"
import script from "./PlayersRoom.vue?vue&type=script&lang=js"
export * from "./PlayersRoom.vue?vue&type=script&lang=js"

import "./PlayersRoom.vue?vue&type=style&index=0&id=5012de2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5012de2e"]])

export default __exports__